export const cdnUrl = import.meta.env.VITE_CDN_URL ?? "https://cdn.econnect.eu";
// eslint-disable-next-line sonarjs/no-hardcoded-ip -- This is a version number, not an IP address
export const iconsVersion = import.meta.env.VITE_ICONS_VERSION ?? "1.0.2.0";
